
import {BeneficiaryAddress} from "./beneficiaryAddress";
import {Landregisterfolio} from "./landregisterfolio";
import {Property} from "./property";
import {BillingAdress} from "./billingAdress";


export class PropertyForm {


  name: string;
  street: string;
  house_number: string;
  zip: string;
  town: string;
  id: string;
  dataResearch: boolean;
  billingAddress: BillingAdress;
  beneficiaryAddress: BeneficiaryAddress;
  landregisterfolios: Array<Landregisterfolio> = [];


  addLandregisterFolio() {
    this.landregisterfolios.push(new Landregisterfolio());
  }


  constructor(property: Property) {
    this.name = property.name;
    this.street = property.street;
    this.house_number = property.house_number;
    this.zip = property.zip;
    this.town = property.town;
    this.id = property.id;
    this.dataResearch = property.dataResearch;
    this.landregisterfolios = property.landregisterfolios;

  }






}
